import { fmtPct, timeAgo } from "./nl";

/* What Changed — compact evidence layer (Figma contract).
   Cells adapt to the real signals available; no fabricated inventory. */

interface Cell { label: string; value: string; color: string; sub: string; testid: string }

export const WhatChanged = ({ overview }: { overview: any }) => {
  const m = overview.metrics;
  const tok = overview.token;
  const cells: Cell[] = [];
  if (m?.tvl_change_24h_pct != null)
    cells.push({ label: "TVL", value: fmtPct(m.tvl_change_24h_pct), sub: "24H protocol movement",
      color: m.tvl_change_24h_pct >= 0 ? "#1fe09c" : "#f0445e", testid: "wc-tvl" });
  if (m?.dominant_share_pct != null && m?.dominant_chain)
    cells.push({ label: "DEPLOYMENT MIX", value: `${m.dominant_share_pct}%`, sub: `${m.dominant_chain} share`,
      color: "#7a3dff", testid: "wc-deployment" });
  if (tok?.change_24h_pct != null)
    cells.push({ label: `${tok.symbol} TOKEN`, value: fmtPct(tok.change_24h_pct), sub: "24H market movement",
      color: tok.change_24h_pct >= 0 ? "#1fe09c" : "#f0445e", testid: "wc-token" });
  if (m?.chain_count != null)
    cells.push({ label: "NETWORK", value: String(m.chain_count), sub: "deployed chains",
      color: "#05d1f0", testid: "wc-network" });
  if (!cells.length) return null;
  return (
    <div className="rounded-[20px] md:rounded-[24px] lg:rounded-[28px] bg-[#030405] border border-[#171a26] px-[16px] py-[16px] md:px-[22px] md:py-[22px] lg:px-[28px] lg:py-[26px]"
      data-testid="what-changed">
      <p className="nl-geist text-[9px] md:text-[10px] lg:text-[11px] leading-[14px] font-semibold text-[#7a3dff] tracking-[0.02em]">WHAT CHANGED</p>
      <h2 className="nl-sg text-[25px] leading-[32px] md:text-[30px] md:leading-[38px] lg:text-[34px] lg:leading-[43px] font-medium text-[#f6f7fc] mt-[10px]">
        Signals before headlines.
      </h2>
      <p className="nl-geist hidden md:block text-[14px] lg:text-[15px] leading-[19px] text-[#9499ad] mt-[8px] max-w-[740px]">
        A compact evidence layer combining protocol movement, deployment composition and the associated token.
      </p>
      <p className="nl-geist md:hidden text-[12px] leading-[16px] text-[#9499ad] mt-[8px]">
        Evidence first: protocol movement, deployment mix and token context.
      </p>
      <div className="mt-[28px] md:mt-[36px] grid grid-cols-2 gap-y-[30px] lg:flex lg:gap-0">
        {cells.map((c, i) => (
          <div key={c.testid} data-testid={c.testid}
            className={`lg:flex-1 ${i > 0 ? "lg:border-l lg:border-[#1a1c2b] lg:pl-[42px]" : ""}`}>
            <p className="nl-geist text-[8px] md:text-[9px] lg:text-[10px] leading-[12px] font-semibold text-[color:var(--nl-text-faint)] uppercase">{c.label}</p>
            <p className="nl-sg text-[23px] leading-[29px] md:text-[26px] md:leading-[33px] lg:text-[28px] lg:leading-[36px] font-medium mt-[8px]"
              style={{ color: c.color }}>{c.value}</p>
            <p className="nl-geist text-[10px] md:text-[11px] lg:text-[12px] leading-[15px] text-[#9499ad] mt-[4px]">{c.sub}</p>
          </div>
        ))}
      </div>
      <p className="nl-mono text-[7px] md:text-[8px] lg:text-[9px] leading-[12px] font-medium text-[color:var(--nl-text-faint)] mt-[30px] uppercase"
        data-testid="wc-provenance">
        LIVE NORMALIZED DATA · DEFILLAMA{tok ? " + KRAKEN" : ""} · {timeAgo(overview.updated_at) || "LIVE"}
      </p>
    </div>
  );
};
